import { PRESIGN_API_OBJECTS } from "../utils/constants";
import PresignUrlApiService from "./docGenApiService";
import { store } from "../state/store"
import { setLoadingState } from "../state/appSlice";
import ElliHost from "./elliHost";

class PreviewDocsService {

    private elliHost;
    constructor() {
        this.elliHost = ElliHost.getInstance();
    }

    public async downloadMetadata(transactionId: string | null, authToken: string, requests: any) {
        store.dispatch(setLoadingState({ loading: true, loadingMessage: "Downloading Metadata" }));
        const service = new PresignUrlApiService();
        const fallbackOrderId = `unknown_${new Date().toISOString().replace(/[:.]/g, "-")}`;
        const orderId = transactionId ?? requests[0]?.RequestId ?? fallbackOrderId;
        const response = await service.getPresignResponse(orderId, authToken, [PRESIGN_API_OBJECTS.METADATA]);
        if (response.result.signedUrls && response.result.signedUrls['metadata.zip']) {
            //download metadata.zip
            await fetch(response.result.signedUrls['metadata.zip'], {
                method: 'GET',
                headers: {
                    'x-bearer-auth': authToken
                }
            })
                .then(async (response) => {
                    if (response.ok) {
                        const blob = await response.blob()
                        if (blob) {
                            const url = window.URL.createObjectURL(blob);
                            const link = document.createElement('a');
                            link.href = url;
                            const downloadName = `${orderId}_metadata.zip`;
                            link.setAttribute('download', downloadName);
                            document.body.appendChild(link);
                            link.click();
                            link.parentNode?.removeChild(link);
                        }
                    }
                    else {
                        console.log("Error fetching metadata.zip", response.status)
                    }
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    store.dispatch(setLoadingState({ loading: false, loadingMessage: '' }));
                })
        }
    }

    public async previewDocument(transactionId: string | null, authToken: string, requests: any) {
        store.dispatch(setLoadingState({ loading: true, loadingMessage: "Requesting Docs" }));

        const service = new PresignUrlApiService();
        const response = await service.getPresignResponse(transactionId ?? requests[0].RequestId, authToken, [PRESIGN_API_OBJECTS.PDF_PACKAGE]);

        if (response.result.signedUrls && response.result.signedUrls['package.pdf']) {
            // Preview pdf 
            this.elliHost.openResource({ target: response.result.signedUrls['package.pdf'] })
                .catch((error) => {
                    console.error("Error opening resource in modal:", error);
                })
                .finally(() => {
                    store.dispatch(setLoadingState({ loading: false, loadingMessage: '' }));
                });
        } else {
            console.log("Error fetching package.pdf");
            store.dispatch(setLoadingState({ loading: false, loadingMessage: '' }));
        }
    }
}

export default PreviewDocsService;